export default "__VITE_ASSET__CvbQAWmR__"